import constants from './style.json';

const logo = require('../../static/images/FSFGLogo.png');

const { Colors, Spacing } = constants;
const Logo = logo;
const breakpoints = {
  mobile: 500,
  tablet: 768,
  desktopSm: 980,
  desktopLg: 1200,
};


export {
  Colors,
  Logo,
  Spacing,
  breakpoints,
};



// WEBPACK FOOTER //
// ./src/constants/style-constants.js